export default "__VITE_ASSET__0ce49a26__"